import React from 'react'

import { useAppSelector } from '@/redux/rootReducer'
import { selectNetworkSpeed } from '@/redux/reducers/statistic.reducer'

import NetworkSpeed from '../components/NetworkSpeed'

export function NetworkSpeedContainer() {
  const networkSpeed = useAppSelector(selectNetworkSpeed)

  return <NetworkSpeed downloadSpeed={networkSpeed.download} uploadSpeed={networkSpeed.upload} />
}

export default NetworkSpeedContainer
